(function() {
  'use strict';
  var $q;
  var $state;
  var $rootScope;
  var _uteLocale;
  var _dataLayerService;
  var _brtSwitchCMS;

  angular.module('eclipseApp').run(dataLayerInject);
  dataLayerInject.$inject = ['ute.datalayer.common.service', '$q', 'uteLocale', '$rootScope', '$state', 'brtSwitchCMS'];

  function dataLayerInject(dataLayerService, q, uteLocale, rootScope, state, brtSwitchCMS) {
    var callbacks = [
      {
        callbackKey: 'account',
        callback: getCurrentAccount
      },
      {
        callbackKey: 'user',
        callback: getCurrentUser
      },
      {
        callbackKey: 'province',
        callback: getCurrentProvince
      },
      {
        callbackKey: 'language',
        callback: getCurrentLanguage
      },
      {
        callbackKey: 'payload',
        callback: getCurrentPayload
      },
      {
        callbackKey: 'eventPayload',
        callback: getEventPayload
      },
      {
        callbackKey: 'errorPayload',
        callback: getErrorPayload
      }
    ];
    $q = q;
    $state = state;
    $rootScope = rootScope;
    _uteLocale = uteLocale;
    _dataLayerService = dataLayerService;
    _brtSwitchCMS = brtSwitchCMS;
    dataLayerService.registerCallbacks(callbacks);
  }

  /** ------------------------------- **/
  /**       CALLBACK FUNCTIONS        **/

  /** ------------------------------- **/

  /**
   * @description A callback function to return the event payload for event directive.
   * @returns A promise containing the event payload will be returned.
   */
  function getEventPayload(key) {
    var payload = {},
      stateName;
    try {
      stateName = $state.current.name.replace(/\./g, '-');
      if (key === 'update') {
        payload = _.merge(
          _dataLayerService.getMappingPayload({ mappingKey: stateName + '-' + key }),
          constructAccountInternetPackage()
        );
      } else if (key === 'remove-from-cart') {
        sessionStorage.removeItem('__adl');
        payload = _dataLayerService.getMappingPayload({ mappingKey: stateName });
        payload.events = { pageView: true };
      } else if (key && typeof key === 'string' && key.match(/global.label.|retail.label./g)) {
        payload = _dataLayerService.getMappingPayload({ mappingKey: stateName });
        payload.page.name = key
          .split('.')
          .slice(2)
          .join('-')
          .replace(/([a-z])([A-Z])/g, '$1-$2')
          .toLowerCase();
        payload.page.hierarchy.push(payload.page.name);
        delete payload.events;
      } else if (key === 'text' || key === 'talk' || key === 'data' || key === 'roaming') {
        payload = _dataLayerService.getMappingPayload({ mappingKey: 'usage-' + key });
      } else if (key === 'retailProfile' && _brtSwitchCMS.brtSwitch.isHybridFlow) {
        payload = {
          page: {
            name: 'create-user',
            hierarchy: ['internet', 'create-user']
          },
          buyflow: {
            name: 'internet new customer',
            serial: getSerial()
          },
          events: {
            buyFlowStart: true
          }
        };
      } else if (key === 'retailConfirmation') {
        if (_brtSwitchCMS.brtSwitch.isHybridFlow && $rootScope.ruiMethods.user.is.agent()) {
          payload = {
            page: {
              name: 'confirm',
              hierarchy: ['internet', 'checkout', 'confirm']
            }
          };
        } else {
          payload = {
            page: {
              name: 'confirm',
              hierarchy: ['internet', 'checkout', 'confirm']
            },
            buyflow: {
              name: 'internet new customer'
            },
            events: {
              purchase: true,
              buyFlowComplete: true
            }
          };
        }
      }
    } catch (error) {
      console.warn('ADL error in getEventPayload method: ', error);
    }
    return $q.when(payload);
  }

  /**
   * @description A callback function to return the error payload for error directive.
   * @returns A promise containing the error payload will be returned.
   */
  function getErrorPayload(key) {
    var payload = {},
      stateName;
    try {
      stateName = $state.current.name.replace(/\./g, '-');
      if (key === 'agreement') {
        payload = _dataLayerService.getMappingPayload({ mappingKey: 'error.' + stateName });
      } else if (key === 'semafone') {
        payload = _dataLayerService.getMappingPayload({ mappingKey: 'error.' + stateName });
      } else if (key === 'paymentMethod') {
        payload = _dataLayerService.getMappingPayload({ mappingKey: 'error.' + stateName });
        if (stateName === 'myAccount-paymentMethod') {
          payload['category'] = 'self_serve';
        }
      }
    } catch (error) {
      console.warn('ADL error in getErrorPayload method: ', error);
    }
    return $q.when(payload);
  }

  /**
   * @description A callback function to return the account info.
   * @returns A promise containing account info will be returned.
   */
  function getCurrentAccount() {
    var returnObject;
    try {
      if ($rootScope.ruiMethods.user.is.loggedIn()) {
        returnObject = {
          accountNumber: _.get($rootScope.userInfo, 'selectedAccountNumber', ''),
          phoneNumber: _.get($rootScope.userInfo, 'selectedSubscriberNo') || getSessionStorage('__adl', 'CTN')
        };
      }
    } catch (error) {
      console.warn('ADL error in getCurrentAccount method: ', error);
    }
    return $q.when(returnObject);
  }

  /**
   * @description A callback function to return the user info.
   * @returns A promise containing user info will be returned.
   */
  function getCurrentUser() {
    var returnObject;
    try {
      returnObject = {
        userType: _.get($rootScope, 'ruiMethods.user.is.agent', _.noop)() ? 'agent' : 'consumer',
        userName: _.get($rootScope, 'userInfo.userID', '') || getSessionStorage('__adl', 'userID')
      };
    } catch (error) {
      console.warn('ADL error in getCurrentUser method: ', error);
    }
    return $q.when(returnObject);
  }

  /**
   * @description A callback function to return the province.
   * @returns A promise containing the province will be returned.
   */
  function getCurrentProvince() {
    var returnObject = {};
    try {
      returnObject = {
        province: _uteLocale.province
      };
    } catch (error) {
      console.warn('ADL error in getCurrentProvince method: ', error);
    }
    return $q.when(returnObject);
  }

  /**
   * @description A callback function to return the language.
   * @returns A promise containing the language will be returned.
   */
  function getCurrentLanguage() {
    var returnObject = {};
    try {
      returnObject = {
        language: _uteLocale.language
      };
    } catch (error) {
      console.warn('ADL error in getCurrentLanguage method: ', error);
    }
    return $q.when(returnObject);
  }

  /**
   * @description
   *  1. This is a callback function for returning a customized payload object
   *  2. To be triggered by trackGlobal function in data layer service.
   * @param stateName: A string containing the current URL state name provided by data layer service.
   * @returns payload: A data layer payload object will be returned.
   */
  function getCurrentPayload(stateName) {
    console.log(stateName);
    var payload = {};
    try {
      if (stateName === 'internet') {
        payload.suppressTracking = _.get(JSON.parse(sessionStorage.getItem('__adl')), 'HSI', false);
      } else if (stateName === 'myAccount.internet.package.change.review' || stateName === 'easylogin/main') {
        payload.suppressTracking = true;
      } else if (stateName === 'myAccount.lostStolenSuspendDevice') {
        payload = _dataLayerService.getMappingPayload({ mappingKey: 'lost-stolen-device,event.selfServeStart' });
      } else if (stateName === 'myAccount.retrievePUK') {
        payload = _dataLayerService.getMappingPayload({ mappingKey: 'receive-puk,event.selfServeStart' });
      } else if (stateName === 'myAccount.resetVoicemailPassword') {
        payload = _dataLayerService.getMappingPayload({ mappingKey: 'resetVoicemailPassword,event.selfServeStart' });
      } else if (stateName === 'myAccount.updateSimCard') {
        payload = _dataLayerService.getMappingPayload({ mappingKey: 'update-sim-card,event.selfServeStart' });
      } else if (stateName === 'myAccount.lostStolenReactivateDevice') {
        payload = _dataLayerService.getMappingPayload({ mappingKey: 'reactivate-device,event.selfServeStart' });
      } else if (stateName === 'myAccount.internetUsage.daily') {
        payload = _dataLayerService.getMappingPayload({ mappingKey: 'internet-daily-usage,event.selfServeComplete' });
      } else if (stateName === 'myAccount.internetUsage.monthly') {
        payload = _dataLayerService.getMappingPayload({ mappingKey: 'internet-usage-monthly,event.selfServeComplete' });
      } else if (stateName === 'myAccount.internetUsage.notification') {
        payload = _dataLayerService.getMappingPayload({ mappingKey: 'internet-usage-alerts,event.selfServeComplete' });
      } else if (stateName.indexOf('setPassword') > -1) {
        payload = {};
      } else if (stateName === 'createUser' && _brtSwitchCMS.brtSwitch.isHybridFlow) {
        payload.suppressTracking = true;
      } else if (stateName === 'confirmation' && _brtSwitchCMS.brtSwitch.isHybridFlow) {
        payload.suppressTracking = true;
      } else {
        payload = isInternetFlow(stateName) ? getPayload(stateName) : {};
      }
    } catch (error) {
      console.warn('ADL error in getCurrentPayload method: ', error);
    }
    return $q.when(payload);
  }

  /** ---------------------------------------------------------------- **/

  /**                INTERNET BUYFLOW SPECIFIC FUNCTIONS               **/
  /** ---------------------------------------------------------------- **/

  function isInternetFlow(state) {
    var states = [
      'internet',
      'cartSummary',
      'createUser',
      'creditCheck',
      'shipToAddress',
      'pickupAtStore',
      'techInstall',
      'takeItWithYou',
      'paymentOptions',
      'review',
      'confirmation',
      'order-review',
      'confirm',
      'myAccount.internet.package.change.review'
    ];
    return states.indexOf(state) > -1;
  }

  /**
   * @description To construct payload object that will be passed to the getCurrentPayload callback function.
   * @param stateName: A string containing the current URL state name provided by data layer service.
   * @returns payload: The final payload object will be returned and consumed by the global tracking function
   */
  function getPayload(stateName) {
    var products = [];
    var payload = {};
    try {
      //Getting agent info if exists
      constructAgentInfoPayload(payload);

      if (stateName !== 'internet') {
        constructBuyflowPayload(payload, getSerial());
      }

      //Getting product info
      if (stateName !== 'confirmation') {
        addProduct(getProductObject(), stateName, products);
        constructProductsPayload(payload, products);
      }

      if (stateName === 'review') {
        constructEcommercePayload({}, JSON.parse(sessionStorage.getItem('profile')));
      }
      if (stateName === 'confirmation') {
        var obj = _.get(JSON.parse(sessionStorage.getItem('__adl')), 'payload');
        var final = _.get(JSON.parse(sessionStorage.getItem('__adl')), 'final');
        sessionStorage.removeItem('__adl');
        _.merge(payload, _.merge(obj, final));
      }
    } catch (error) {
      console.warn('ADL error in getPayload method: ', error);
    }
    return payload;
  }

  /**
   * @description To construct the products array object based on the passed in parameters
   * @param obj: An object containing all the required information. To be added to the 'products' array;
   * @param stateName: A string contains the stateName
   * @param products: The result products array containing the product object(s)
   */
  function addProduct(obj, stateName, products) {
    var product;

    //For adding products within an array
    if (obj && obj.length > 0) {
      obj.forEach(function(addon) {
        addProduct(addon, stateName, products);
      });
    }

    //For adding a single product
    else if (!_.isEmpty(obj)) {
      if (stateName !== 'internet') {
        product = {
          name: obj.name.trim(),
          ID: obj.ID,
          category: obj.category,
          subCategory: obj.subCategory
        };
      }

      if (stateName === 'review') {
        var final_products = [];
        var payload = {};
        var final = {
          MSF: obj.MSF,
          quantity: obj.quantity,
          category: 'internet',
          subCategory: 'package'
        };
        _.merge(final, product);
        final_products.push(final);

        payload = {
          ecommerce: {
            name: obj.name.trim(),
            ID: obj.ID,
            products: final_products
          },
          events: {
            addToCart: true
          }
        };
        // payload = {
        //   ecommerce: {
        //     products: final_products
        //   }
        // };
        updateSessionStorage('__adl', { final: payload });
      }

      if (product) {
        products.push(product);
      }
    }
  }

  /**
   * @description To construct the eCommerce payload
   * @param products: An array containing all the products
   * @param payload: The eCommerce object will be merged into 'payload'
   */
  function constructProductsPayload(payload, products) {
    if (products.length > 0) {
      var obj = {
        ecommerce: {
          products: products
        }
      };
      merge(payload, obj);
    }
  }

  /**
   * @description To construct the buyflow payload
   * @param serial: A string containing the serial ID / add to cart ID
   * @param payload: The buyflow object will be merged into 'payload'
   */
  function constructBuyflowPayload(payload, serial) {
    if (serial) {
      var obj = {
        buyflow: {
          serial: serial
        }
      };
      merge(payload, obj);
    }
  }

  /**
   * @description To construct the account.internet.package payload
   * @param serial: A string containing the package sku
   * @param payload: The sku object will be merged into 'payload'
   */
  function constructAccountInternetPackage() {
    var obj = {
      account: {
        internet: {
          package: _.get(JSON.parse(sessionStorage.getItem('__adl')), 'existingPackage', '')
        }
      }
    };
    return obj;
  }

  /**
   * @description To construct the eCommerce payload
   * @param payload: The eCommerce object will be merged into 'payload'
   * @param profile: containing the final eCommerce info
   */
  function constructEcommercePayload(payload, profile) {
    if (!_.isEmpty(profile)) {
      var obj = {
        ecommerce: {
          transactionID: _.get(profile, 'paymentOptions.data.transactionID', ''),
          currency: 'CAD',
          tax: Number(_.get($rootScope, 'shoppingCart.total.tax', '0.00'))
            .toFixed()
            .toString(),
          province: getBillingAddress(profile, 'province').toLowerCase(),
          postal: getBillingAddress(profile, 'postalCode'),
          fulfillmentMethod: _.get(profile, 'fulfillment.selectedOption', '')
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            .toLowerCase(),
          paymentMethods: [_.get(profile, 'paymentOptions.selectedPaymentOption', '')],
          fees: [
            {
              type: 'installation fee',
              amount: Number(_.get(profile, 'review.data.orderSummaryTotal.oneTime.total', '0.00'))
                .toFixed(2)
                .toString()
            }
          ]
        }
      };
      merge(payload, obj);
    }
  }

  /**
   * @description To construct the eCommerce payload
   * @param profile: containing the final eCommerce info
   * @param item: the info to retrieve within the address object.
   */
  function getBillingAddress(profile, item) {
    var addressType = _.get(profile, 'createUser.billingAddress', '');
    if (addressType === 'anotherAddress') {
      var addr_item = _.get(profile, 'createUser.data.anotherBillingAddress.address.' + item, '');
      if (addr_item) {
        var obj = {};
        obj[item] = addr_item;
        updateSessionStorage('__adl', obj);
      }
      return _.get(JSON.parse(sessionStorage.getItem('__adl')), item, '');
    } else if (addressType === 'existingBillingAddress') {
      return _.get(profile, 'createUser.data.existingBillingAddress.address.' + item, '');
    } else if (addressType === 'serviceAddress') {
      return _.get(profile, 'createUser.data.serviceAddress.' + item, '');
    }
    return '';
  }

  /**
   * @description To construct the product object
   * @returns product: The product object will be returned
   */
  function getProductObject() {
    var obj = _.get(
      $rootScope,
      'shoppingCart.' + _uteLocale.language + '.services.internet.tier["0"].products["0"].offers["0"]'
    );
    var product = {};

    if (!_.isEmpty(obj)) {
      product.name = obj.name;
      product.ID = obj.offerId;
      product.category = 'internet';
      product.subCategory = 'package';
      product.MSF = Number(_.get(obj, 'offerPrice.price', 0))
        .toFixed(2)
        .toString();
      product.quantity = '1';
    }
    return product;
  }

  /**
   * @description To get the serial number that will be uniquely identify the current shopping cart session.
   * @returns The serial number will be returned
   */
  function getSerial() {
    return _.get($rootScope, 'atg.userId.value', '');
  }

  /**
   * @description To construct the account payload with agent information.
   * @param payload: The account object containing the agent info will be merged into 'payload'
   */
  function constructAgentInfoPayload(payload) {
    var agentInfo = {};
    if ($rootScope.ruiMethods.user.is.agent()) {
      agentInfo = {
        account: {
          dealerCode: $rootScope.ruiMethods.agent.storeCode().toLowerCase(),
          agentType: $rootScope.ruiMethods.agent.type().toLowerCase()
        }
      };
      merge(payload, agentInfo);
    }
  }

  /** --------------------------------------------- **/
  /**                HELPER FUNCTIONS               **/

  /** --------------------------------------------- **/

  /**
   * @description To merge the payload object with obj and add to sessionStorage __adl
   * @param payload: Will be merged with obj and stored in sessionStorage __adl
   * @param obj: The object to be merged with payload.
   */
  function merge(payload, obj) {
    _.merge(payload, obj);
    updateSessionStorage('__adl', { payload: payload });
  }

  function updateSessionStorage(key, obj) {
    var existingData = JSON.parse(sessionStorage.getItem(key)) || {};
    var newData = _.merge(existingData, obj);
    sessionStorage.setItem(key, JSON.stringify(newData));
  }

  function getSessionStorage(key, path) {
    return _.get(JSON.parse(sessionStorage.getItem(key)), path, '');
  }
})();
